import { HttpInterceptor, HttpRequest, HttpEvent, HttpHandler } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, timeout } from 'rxjs/operators';
import { LoadingIndicatorService } from '#services';

@Injectable({
  providedIn: 'root',
})
export class HttpLoadingInterceptor implements HttpInterceptor {
  private loadingIndicatorService = inject(LoadingIndicatorService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Only track API calls
    const isApiCall = req.url.includes('/api');

    if (isApiCall) {
      this.loadingIndicatorService.incrementRequests();
    }

    return next.handle(req).pipe(
      timeout(30_000), // 30 second timeout
      catchError(error => throwError(() => error)),
      finalize(() => {
        if (isApiCall) {
          this.loadingIndicatorService.decrementRequests();
        }
      })
    );
  }
}
